import Link from "next/link";
import Icon from "@/components/ui/AppIcon";

export default function Footer() {
  const platformLinks = [
    { label: "Agents", href: "#agents", id: "footer_agents" },
    { label: "Workflows", href: "#workflows", id: "footer_workflows" },
    { label: "Observability", href: "#observability", id: "footer_observability" },
    { label: "Security", href: "#security", id: "footer_security" },
  ];

  const resourceLinks = [
    { label: "Documentation", href: "#docs", id: "footer_docs" },
    { label: "API Reference", href: "#api", id: "footer_api" },
    { label: "Community", href: "#community", id: "footer_community" },
    { label: "Blog", href: "#blog", id: "footer_blog" },
  ];

  const companyLinks = [
    { label: "About", href: "#about", id: "footer_about" },
    { label: "Customers", href: "#customers", id: "footer_customers" },
    { label: "Careers", href: "#careers", id: "footer_careers" },
    { label: "Contact", href: "/contact", id: "footer_contact" },
  ];

  const legalLinks = [
    { label: "Privacy", href: "#privacy", id: "footer_privacy" },
    { label: "Terms", href: "#terms", id: "footer_terms" },
  ];

  const socialLinks = [
    { label: "LinkedIn", href: "#linkedin", icon: "LinkIcon", id: "footer_linkedin" },
    { label: "GitHub", href: "#github", icon: "CodeBracketIcon", id: "footer_github" },
  ];

  return (
    <footer className="bg-neutral-950 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Row 1: Link Groups */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Platform */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wide">
              Platform
            </h3>
            <ul className="space-y-3">
              {platformLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-neutral-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wide">
              Resources
            </h3>
            <ul className="space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-neutral-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wide">
              Company
            </h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-neutral-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Row 2: Legal + Social + Copyright */}
        <div className="flex flex-col md:flex-row items-center justify-between border-t border-white/5 pt-8 gap-4">
          {/* Legal */}
          <div className="flex items-center gap-4 text-xs text-neutral-500">
            {legalLinks.map((link, index) => (
              <span key={link.id} className="flex items-center gap-4">
                <Link href={link.href} className="hover:text-white transition-colors">
                  {link.label}
                </Link>
                {index < legalLinks.length - 1 && <span>·</span>}
              </span>
            ))}
          </div>

          {/* Social */}
          <div className="flex items-center gap-4">
            {socialLinks.map((link) => (
              <Link
                key={link.id}
                href={link.href}
                className="text-neutral-400 hover:text-blue-400 transition-colors"
                aria-label={link.label}
              >
                <Icon name={link.icon as any} size={20} />
              </Link>
            ))}
          </div>

          {/* Copyright */}
          <div className="text-xs text-neutral-500">© 2026 e2eint</div>
        </div>

        {/* Ethics Note */}
        <div className="mt-8 pt-6 border-t border-white/5 text-center">
          <p className="text-xs text-neutral-500">
            We don&apos;t sell middleware licenses. We design and deliver integrations.
          </p>
        </div>
      </div>
    </footer>
  );
}